module.exports = __webpack_public_path__ + "img/aygaz-step-into-the-future-08.60bfefc8.jpg";